<script setup>

import Modal from '@/components/common/other/Modal';
import MultiSearchDropDown from '@/components/common/input/MultiSearchDropDown';
import Button from "@/components/common/input/Button";
import StaticTooltip from "@/components/common/other/StaticTooltip";
import StaticWidget from "@/components/common/other/StaticWidget";
import CheckBox from "@/components/common/input/CheckBox";
import DateInput from "@/components/common/input/DateInput";
import AddressSelectionTile from "@/components/orders/AddressSelectionTile";
import AddressDetail from "@/components/orders/AddressDetail";
import Address from "@/classes/global/Address";
import PurchaseOrderItemDetails from "@/components/orders/PurchaseOrderItemDetails";
import PurchaseOrderStatus from "@/components/orders/PurchaseOrderStatus";

import {ref, inject, computed, toRefs, reactive, onMounted, onUnmounted} from 'vue';

const purchaseOrder = inject('purchaseOrder');

let modalAddress = ref(new Address());

const selectCorrectModel = computed(() => {

  if (purchaseOrder.value.isNew) return modalAddress.value;
  if (purchaseOrder.value.isEdit) return purchaseOrder.value[purchaseOrder.value.currentTile];
})

const getModalTitle = computed(() => {

  if (purchaseOrder.value.isNew) return 'New Company';

  return 'Edit Company';
})

const getRequiredFields = computed(() => {

  return purchaseOrder.value.metaData.validatedFields.filter((item) => {
    return item.addressType === purchaseOrder.value.currentTile
  })

})


function handleSelectedTile(tile) {

  for (const each in purchaseOrder.value.addressSelection) {

    purchaseOrder.value.addressSelection[each].active = false;
  }

  purchaseOrder.value.addressSelection[tile].active = true;
  purchaseOrder.value.currentTile = tile;

}

function handleAddressType(type) {

  purchaseOrder.value.openAddressModal = true;

  if (type === 'new') {

    purchaseOrder.value.isNew = true;
    purchaseOrder.value.isEdit = false;

  } else {

    // Must be edit
    Object.assign(purchaseOrder.value.currentEditAddress, purchaseOrder.value[purchaseOrder.value.currentTile]);

    purchaseOrder.value.isEdit = true;
    purchaseOrder.value.isNew = false;

  }

}

function handleSaveNewAddress() {

    if (purchaseOrder.value.isNew) {

      if(validate(modalAddress.value)) {

        purchaseOrder.value[purchaseOrder.value.currentTile].companyId = 'id from server'
        purchaseOrder.value[purchaseOrder.value.currentTile].companyName = modalAddress.value.companyName;
        purchaseOrder.value.openAddressModal = false;
        purchaseOrder.value.addressSelection[purchaseOrder.value.currentTile].complete = true;

        modalAddress.value = new Address();

        return;
      }

    }

}

function validate(model) {

  purchaseOrder.value.addressSelection[purchaseOrder.value.currentTile].isValid = true;

  let validatedFields = purchaseOrder.value.metaData.validatedFields.filter((item) => {
    return item.addressType === purchaseOrder.value.currentTile && item.validate
  })

  validatedFields.forEach(item => {

    if(model[item.modelName] === '' && item.validate) {

      item.trigger.value = true;
      purchaseOrder.value.addressSelection[purchaseOrder.value.currentTile].isValid = false;
    }

  })

  return purchaseOrder.value.addressSelection[purchaseOrder.value.currentTile].isValid;
}

function mapSelectedAddress(address) {

  purchaseOrder.value[purchaseOrder.value.currentTile].companyId = address.id
  purchaseOrder.value[purchaseOrder.value.currentTile].companyName = address.originValue;
  purchaseOrder.value.addressSelection[purchaseOrder.value.currentTile].complete = true;

}

function handleCompanyClear() {

  purchaseOrder.value.addressSelection[purchaseOrder.value.currentTile].complete = false;
  purchaseOrder.value[purchaseOrder.value.currentTile] = new Address();

  purchaseOrder.value.isNew = true;
  purchaseOrder.value.isEdit = false;
}

function handleAddressModalClose() {

  if (purchaseOrder.value.isNew) return modalAddress.value = new Address();
}


function handleUseAddress() {

  if (checkAddressForChanges()) return handleAddressChange();

  purchaseOrder.value.openAddressModal = false;

}

function checkAddressForChanges() {

  for (const each in purchaseOrder.value[purchaseOrder.value.currentTile]) {

    if (purchaseOrder.value[purchaseOrder.value.currentTile][each].toString().trim() !==
        purchaseOrder.value.currentEditAddress[each].toString().trim()) {

      console.log('has changed')
      return true;
    }

  }
}

function handleAddressChange() {

  purchaseOrder.value[purchaseOrder.value.currentTile].companyId = 0;
  purchaseOrder.value.openAddressModal = false;
}

function handleClearFields() {

  if (purchaseOrder.value.isEdit) {

    purchaseOrder.value[purchaseOrder.value.currentTile] = new Address();
    purchaseOrder.value.addressSelection[purchaseOrder.value.currentTile].complete = false;

    return;
  }

  modalAddress.value = new Address();
}

function setCurrentCompany() {

  return purchaseOrder.value.currentTile.charAt(0).toUpperCase() +
      purchaseOrder.value.currentTile.slice(1);

}

</script>

<template>

  <div class="cmp-purchase-order-entry">
    <StaticWidget
        height="740"
        background="#fafafa"
        title="Create PO Details">
            <template #right-side>
              <Button
                  type="warning"
                  icon="<i class='fa-solid fa-folder-plus'></i>"
                  text="Add/View Docs">
              </Button>
             <Button
                 icon="<i class='fa-light fa-floppy-disk'></i>"
                 text="Save & Submit">
             </Button>
            </template>
      <div class="cmp-purchase-order-entry_header-wrapper">
        <i class="fa-regular fa-memo-circle-info" style="color: #0c92bc; margin-left: 5px"></i>
        <span class="cmp-purchase-order-entry_heading">Header Information</span>
      </div>
      <div class="cmp-purchase-order-entry_section-container-wide">
        <div class=" global-flex-layout">
          <TextInput
              :requiredField="false"
              :maxLength="50"
              :width="220"
              :label-width="50"
              label="PO No.">
          </TextInput>
          <TextInput
              :requiredField="false"
              :maxLength="50"
              :width="220"
              :label-width="80"
              label="PO Split No.">
          </TextInput>
          <MultiSearchDropDown
              :requiredField="false"
              :width="200"
              :allowCustomValue="false"
              placeholder="Select or Search...."
              :label-width="45"
              label="Mode"
              :selectPrimitiveValue="true">
          </MultiSearchDropDown>
          <MultiSearchDropDown
              :requiredField="false"
              :width="200"
              :allowCustomValue="false"
              placeholder="Select or Search...."
              :label-width="45"
              label="Terms"
              :selectPrimitiveValue="true">
          </MultiSearchDropDown>
          <DateInput
              :labelWidth="60"
              :requiredField="false"
              label="PO Date">
            <el-date-picker
                :clearable="false"
                value-format="DD-MMM-YY"/>
          </DateInput>
          <DateInput
              style="margin-left: 10px"
              :labelWidth="90"
              :requiredField="false"
              label="Required Date">
            <el-date-picker
                :clearable="false"
                value-format="DD-MMM-YY"/>
          </DateInput>
          <DateInput
              style="margin-left: 20px"
              :labelWidth="70"
              :requiredField="false"
              label="Ready Date">
            <el-date-picker
                :clearable="false"
                value-format="DD-MMM-YY"/>
          </DateInput>
        </div>
        <div class="global-flex-layout" style="margin-top: 10px;">
          <TextInput
              :requiredField="false"
              :maxLength="50"
              :width="220"
              :label-width="50"
              label="Pieces">
          </TextInput>
          <TextInput
              :requiredField="false"
              :maxLength="50"
              :width="220"
              :label-width="80"
              label="Gross Weight">
          </TextInput>
          <TextInput
              :requiredField="false"
              :maxLength="50"
              :width="200"
              :label-width="45"
              label="Cube">
          </TextInput>
          <CheckBox
              style="margin-left: 177px"
              :label-width="35"
              label="Urgent">
          </CheckBox>
        </div>
      </div>
      <div class="cmp-purchase-order-entry_header-wrapper">
        <i class="fa-regular fa-calendar-check" style="color: #0c92bc; margin-left: 5px"></i>
        <span class="cmp-purchase-order-entry_heading">Order Status</span>
        <span @click="purchaseOrder.openOrderStatusModal = true" class="cmp-purchase-order-entry_large-view-button"> Large View
          <i class="fa-regular fa-window-restore" style="color: #b15c19; font-size: 16px;"></i>
        </span>
      </div>
      <div class="cmp-purchase-order-entry_section-container-wide" style="background-color: #f6f6f6">
        <PurchaseOrderStatus
            :height="60"
            :key="purchaseOrder.openOrderStatusModal"
            v-model="purchaseOrder.orderStatusList">
        </PurchaseOrderStatus>
      </div>
      <Modal
          v-model="purchaseOrder.openOrderStatusModal"
          :showClose="false"
          title="Order Status"
          width="1800px"
          height="440px">
        <template #icon><i class="fa-solid fa-pen-to-square" style="color: #3f9968; font-size: 18px;"></i></template>
        <template #body>
          <PurchaseOrderStatus
              :height="400"
              :key="purchaseOrder.openOrderStatusModal"
              v-model="purchaseOrder.orderStatusList">
          </PurchaseOrderStatus>
        </template>
      </Modal>
      <div class="cmp-purchase-order-entry_header-wrapper">
        <i class="fa-regular fa-cubes-stacked" style="color: #0c92bc; margin-left: 5px"></i>
        <span class="cmp-purchase-order-entry_heading">Item Details</span>
        <span @click="purchaseOrder.openItemDetailsModal = true" class="cmp-purchase-order-entry_large-view-button"> Large View
          <i class="fa-regular fa-window-restore" style="color: #b15c19; font-size: 16px;"></i>
        </span>
      </div>
      <div class="cmp-purchase-order-entry_section-container-wide" style="background-color: #f7faff">
        <PurchaseOrderItemDetails
            :height="60"
            :key="purchaseOrder.openItemDetailsModal"
            v-model="purchaseOrder.itemDetailsList">
        </PurchaseOrderItemDetails>
      </div>
      <Modal
          v-model="purchaseOrder.openItemDetailsModal"
          :showClose="false"
          title="Item Details"
          width="1800px"
          height="440px">
        <template #icon><i class="fa-solid fa-pen-to-square" style="color: #3f9968; font-size: 18px;"></i></template>
        <template #body>
          <PurchaseOrderItemDetails
              :height="400"
              :key="purchaseOrder.openItemDetailsModal"
              v-model="purchaseOrder.itemDetailsList">
          </PurchaseOrderItemDetails>
        </template>
      </Modal>
      <div class="cmp-purchase-order-entry_address-movement">
        <div class="cmp-purchase-order-entry_address-movement-container">
          <div class="cmp-purchase-order-entry_header-wrapper">
            <i class="fa-regular fa-align-left" style="color:  #0c92bc; margin-left: 5px"></i>
            <span class="cmp-purchase-order-entry_heading">Address Details</span>
          </div>
          <div class="cmp-purchase-order-entry_section-container-wide cmp-purchase-order-entry_section-container-small">
            <div class="cmp-purchase-order-entry_double-layout">
              <div>
                <AddressSelectionTile
                    @selected="handleSelectedTile('supplier')"
                    v-model="purchaseOrder.addressSelection.supplier">
                  <template #required-address>
<!--                    <div v-if="checkValidation">Please add a supplier</div>-->
                  </template>
                  <template #icon>
                    <i class="fa-thin fa-earth-americas" style="font-size: 30px;"></i>
                  </template>
                  <template #text>
                    Supplier
                  </template>
                </AddressSelectionTile>
                <AddressSelectionTile
                    @selected="handleSelectedTile('consignee')"
                    v-model="purchaseOrder.addressSelection.consignee">
                  <template #icon>
                    <i class="fa-thin fa-clipboard-check" style="font-size: 35px;"></i>
                  </template>
                  <template #text>
                    Consignee
                  </template>
                </AddressSelectionTile>
                <AddressSelectionTile
                    @selected="handleSelectedTile('agent')"
                    v-model="purchaseOrder.addressSelection.agent">
                  <template #icon>
                    <i class="fa-thin fa-people-arrows" style="font-size: 28px; margin-left: -5px"></i>
                  </template>
                  <template #text>
                    <div style="margin-right: 30px">Agent</div>
                  </template>
                </AddressSelectionTile>
              </div>

              <div class="global-css_vertical-form-layout">
                <MultiSearchDropDown
                    :key="purchaseOrder[purchaseOrder.currentTile].companyName"
                    v-model="purchaseOrder[purchaseOrder.currentTile].companyName"
                    @select="mapSelectedAddress"
                    @clear="handleCompanyClear()"
                    :requiredField="false"
                    :width="320"
                    :useServerSearch="true"
                    :disableFilter="purchaseOrder[purchaseOrder.currentTile].companyName?.length > 0"
                    :maxLength="70"
                    searchType="shipper"
                    :label-width="100"
                    :allowCustomValue="false"
                    placeholder="Select or Search...."
                    :label="setCurrentCompany()"
                    :selectPrimitiveValue="true">
                </MultiSearchDropDown>
                <TextInput
                    v-model="purchaseOrder[purchaseOrder.currentTile].addressLine1"
                    :maxLength="50"
                    :width="320"
                    :disable="true"
                    :label-width="100"
                    label="Address Line 1">
                </TextInput>
                <TextInput
                    v-model="purchaseOrder[purchaseOrder.currentTile].addressLine2"
                    :maxLength="50"
                    :disable="true"
                    :width="320"
                    :label-width="100"
                    label="Address Line 2">
                </TextInput>
                <TextInput
                    v-model="purchaseOrder[purchaseOrder.currentTile].city"
                    :maxLength="50"
                    :disable="true"
                    :width="320"
                    :label-width="100"
                    label="City">
                </TextInput>
                <TextInput
                    v-model="purchaseOrder[purchaseOrder.currentTile].postCode"
                    :maxLength="50"
                    :disable="true"
                    :width="320"
                    :label-width="100"
                    label="Post Code">
                </TextInput>
                <TextInput
                    v-model="purchaseOrder[purchaseOrder.currentTile].county"
                    :maxLength="50"
                    :disable="true"
                    :width="320"
                    :label-width="100"
                    label="County">
                </TextInput>
                <TextInput
                    v-model="purchaseOrder[purchaseOrder.currentTile].country"
                    :maxLength="50"
                    :disable="true"
                    :width="320"
                    :label-width="100"
                    label="Country">
                </TextInput>
              </div>
              <div>
                <Button
                    @click="handleAddressType('new')"
                    type="plain"
                    icon="<i class='fa-duotone fa-address-card'></i>"
                    text="New">
                </Button>
                <Button
                    style="margin-top: 6px"
                    v-if="purchaseOrder[purchaseOrder.currentTile].companyName"
                    @click="handleAddressType('edit')"
                    type="info"
                    text="Edit">
                </Button>
                <!--                {{purchaseOrder[purchaseOrder.currentTile].companyId}}-->
                <!--                {{purchaseOrder[purchaseOrder.currentTile].companyName}}-->
              </div>
            </div>
          </div>
        </div>
        <div class="cmp-purchase-order-entry_address-movement-container">
          <div class="cmp-purchase-order-entry_header-wrapper">
            <i class="fa-regular fa-ferry" style="color: #0c92bc; margin-left: 5px"></i>
            <span class="cmp-purchase-order-entry_heading">Movement Details</span>
          </div>
          <div class="cmp-purchase-order-entry_section-container-wide cmp-purchase-order-entry_section-container-small">
            <div class="cmp-purchase-order-entry_double-layout">
              <div class="global-css_vertical-form-layout">
                <MultiSearchDropDown
                    :requiredField="false"
                    :width="320"
                    :label-width="100"
                    :allowCustomValue="false"
                    placeholder="Select or Search...."
                    label="Origin Port"
                    :selectPrimitiveValue="true">
                </MultiSearchDropDown>
                <MultiSearchDropDown
                    :requiredField="false"
                    :width="320"
                    :label-width="100"
                    :allowCustomValue="false"
                    placeholder="Select or Search...."
                    label="Destination Port"
                    :selectPrimitiveValue="true">
                </MultiSearchDropDown>
                <TextInput
                    :requiredField="false"
                    :maxLength="50"
                    :width="320"
                    :label-width="100"
                    label="BOL Number">
                </TextInput>
                <TextInput
                    :requiredField="false"
                    :maxLength="50"
                    :width="320"
                    :label-width="100"
                    label="Carrier Name">
                </TextInput>
                <TextInput
                    :requiredField="false"
                    :maxLength="50"
                    :width="320"
                    :label-width="100"
                    label="Vessel Name">
                </TextInput>
                <TextInput
                    :requiredField="false"
                    :maxLength="50"
                    :width="320"
                    :label-width="100"
                    label="Voyage Name">
                </TextInput>
              </div>
              <div>
                <span class="cmp-purchase-order-entry_movement-dates-header" style="margin-left: 100px">Estimated</span>
                <span class="cmp-purchase-order-entry_movement-dates-header" style="margin-left: 130px">Actual</span>
                <div class="global-css_vertical-form-layout">
                  <div class="global-flex-layout" style="margin-top: 10px;">
                    <DateInput
                        :labelWidth="85"
                        :requiredField="false"
                        label="Pickup Date">
                      <el-date-picker
                          :clearable="false"
                          value-format="DD-MMM-YY"/>
                    </DateInput>
                    <DateInput
                        style="margin-left: 50px"
                        :requiredField="false">
                      <el-date-picker
                          :clearable="false"
                          value-format="DD-MMM-YY"/>
                    </DateInput>
                  </div>
                  <div class="global-flex-layout">
                    <DateInput
                        :labelWidth="85"
                        :requiredField="false"
                        label="Departure Date">
                      <el-date-picker
                          :clearable="false"
                          value-format="DD-MMM-YY"/>
                    </DateInput>
                    <DateInput
                        style="margin-left: 50px"
                        :requiredField="false">
                      <el-date-picker
                          :clearable="false"
                          value-format="DD-MMM-YY"/>
                    </DateInput>
                  </div>
                  <div class="global-flex-layout">
                    <DateInput
                        :labelWidth="85"
                        :requiredField="false"
                        label="Arrival Date">
                      <el-date-picker
                          :clearable="false"
                          value-format="DD-MMM-YY"/>
                    </DateInput>
                    <DateInput
                        style="margin-left: 50px"
                        :requiredField="false">
                      <el-date-picker
                          :clearable="false"
                          value-format="DD-MMM-YY"/>
                    </DateInput>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

    </StaticWidget>
    <Modal
        v-model="purchaseOrder.openAddressModal"
        @close="handleAddressModalClose()"
        :showClose="false"
        :title="getModalTitle"
        width="560px"
        height="240px">
      <template #icon><i class="fa-solid fa-pen-to-square" style="color: #3f9968; font-size: 18px;"></i></template>
      <template #body>
        <AddressDetail
            :requiredFields="getRequiredFields"
            @clear-fields="handleClearFields()"
            v-model="selectCorrectModel">
        </AddressDetail>
      </template>
      <template #footer>
        <StaticTooltip v-if="purchaseOrder.isEdit" :icon="false">
          <template #content>
            <div style="width: 200px">
              <span style="margin-left: 4px;"><strong>Use Address</strong> will allow you to use any current changes
                to the address for this PO only. This will not save to your address records.</span>
            </div>
          </template>
          <div style="margin-left: 90px" class="global-info-icon">&#128712;</div>
        </StaticTooltip>
        <Button
            v-if="purchaseOrder.isEdit"
            @click="handleUseAddress()"
            text="Use Address"
            type="toolbar"
            icon="<i class='fa-regular fa-align-left'></i>">
        </Button>
        <Button
            v-if="purchaseOrder[purchaseOrder.currentTile].companyId === 0 || purchaseOrder.isNew"
            @click="handleSaveNewAddress()"
            text="Save">
        </Button>
        <Button
            v-if="purchaseOrder[purchaseOrder.currentTile].companyId !== 0 && purchaseOrder.isEdit"
            @click="handleSaveNewAddress()"
            type="info"
            text="Update">
        </Button>
      </template>
    </Modal>
  </div>

</template>

<style lang="scss" scoped>

.cmp-purchase-order-entry {

  &_section-container-wide {
    border: 1px solid var(--border-color);
    padding: 20px 15px 20px 15px;
    border-radius: var(--rounded-corners);
    border-left: 6px solid var(--left-border-highlight);
    background-color: #fcfcfc;
    width: 1758px;
  }

  &_section-container-small {
    width: 850px;
    height: 210px;
  }

  &_heading {
    font-size: 13px;
    margin-left: 5px;
    font-weight: bold;
    padding-top: 2px;
  }

  &_header-wrapper {
    display: flex;
    margin: 10px 0 3px 2px
  }

  &_address-movement {
    display: grid;
    gap: 20px;
    grid-template-columns: max-content max-content;
  }

  &_address-movement-container {
    width: 50%;
    height: auto;
  }

  &_double-layout {
    display: flex;
    gap: 40px;
  }

  &_movement-dates-header {
    font-size: 12px;
    font-weight: bold;
  }

  &_large-view-button {
    margin-left: auto;
    margin-right: 50px;
    font-size: 12px;
    cursor: pointer;
  }

  @media screen and (max-width: 1840px) {
    &_large-view-button {
      visibility: hidden;
    }
  }
}

</style>
